let computed = require('../computed/account/orders-list');
let _ = require('lodash');

const ALL_STATUSES = [
    {
        id: 1,
        name: 'Черновик'
    },
    {
        id: 2,
        name: 'На оформлении'
    },
    {
        id: 3,
        name: 'Ожидает оплату'
    },
    {
        id: 4,
        name: 'Ожидает документы'
    },
    {
        id: 5,
        name: 'Выполнен'
    },
    {
        id: 6,
        name: 'Архив'
    },
    {
        id: 7,
        name: 'Предчерновик'
    }
];

const ALL_TYPES = [
    {
        id: 1,
        name: 'Online выборка'
    },
    {
        id: 2,
        name: 'Offline выборка'
    },
    {
        id: 3,
        name: 'Offline адр. план'
    },
    {
        id: 4,
        name: 'Индивидуальная выборка'
    }
];

const ORDER_TYPE_MAP = {
    all: [1, 2, 3, 4, 5, 6],
    active: [1, 2, 3, 4],
    inactive: [5, 6]
};

function setStatusFilterItem ({ path, value }, state) {
    state.set(['account', 'orders', 'list', 'stateFilter', path, 'isChecked'], value);
}

function setTypeFilterItem ({ path, value }, state) {
    state.set(['account', 'orders', 'list', 'typeFilter', path, 'isChecked'], value);
}

module.exports = {
    setComputedFields (args, state) {
        computed.formatOrderList(state);
        computed.computeSelectedStatesArray(state);
        computed.computeSelectedTypesArray(state);
        computed.queryObject(state);
    },

    setStateFormUrlClient ({ type }, state) {
        let typeFilter = type || 'all';

        state.set(['account', 'orders', 'list', 'selectedTypeFilter'], typeFilter);
    },

    setShouldRestoreFiltersFromLocalStorage ({ assigned, status, text, type }, state) {
        state.set(['account', 'orders', 'shouldRestoreFilters'], !assigned && !status && !text && !type);
    },

    setStateFormUrlManager ({ assigned, status, text, type, orderId }, state) {
        let radioFilter = assigned || 'any';
        state.set(['account', 'orders', 'list', 'selectedRadioFilter'], radioFilter);
        state.set(['account', 'orders', 'queryOrderId'], orderId);

        if (status) {
            let statusIds = _.map(status, (id) => Number(id));
            _.forEach(statusIds, (id) => {
                setStatusFilterItem({ path: id, value: true }, state);
            });
        }

        if (type) {
            let ids = _.map(_.filter(type, (id) => !isNaN(id)), (id) => Number(id));
            _.forEach(ids, (id) => {
                setTypeFilterItem({ path: id, value: true }, state);
            });
        }

        state.set(['account', 'orders', 'list', 'filterText'], text);
    },

    resetPaging (args, state) {
        state.set(['account', 'orders', 'list', 'page'], 1);
        state.set(['account', 'orders', 'list', 'isAllLoaded'], false);
    },

    setPagingDefaultsIfNeeded (args, state) {
        state.apply(['account', 'orders', 'list', 'page'], (page) => page || 1);
        state.apply(['account', 'orders', 'list', 'count'], (count) => count || 15);
    },


    incrementCurrentPage (args, state) {
        state.apply(['account', 'orders', 'list', 'page'], (page) => page + 1);
    },

    /**
     * Получаем список заказов пользователя
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    getOrdersList (args, state, output, { locator, context }) {
        const API = locator.resolve('api');

        const allLoaded = state.get(['account', 'orders', 'list', 'isAllLoaded']);
        const page = state.get(['account', 'orders', 'list', 'page']);
        const count = state.get(['account', 'orders', 'list', 'count']);
        const assigned = state.get(['account', 'orders', 'list', 'selectedRadioFilter']);
        const type = state.get(['account', 'orders', 'list', 'selectedTypeFilter']);
        const text = state.get(['account', 'orders', 'list', 'filterText']);
        const orderTypeForManager = state.get(['account', 'orders', 'computed', 'list', 'selectedTypes']);
        let status = state.get(['account', 'orders', 'computed', 'list', 'selectedStates']);

        if (type) {
            status = ORDER_TYPE_MAP[type];
        }

        const queryData = _.omitBy({ page, count, status, assigned, text, type: orderTypeForManager }, _.isUndefined);

        if (allLoaded) {
            output.success();
            return;
        }

        const request = API.getOrders(context, locator, { queryData });

        request
            .then((data) => {
                const code = _.get(data, 'status.code');

                if (code === 200) {
                    const ordersList = _.get(data, 'content');
                    output.success({ ordersList });

                    return;
                }

                if (code === 404) {
                    output.notFound();

                    return;
                }

                output.error({ error: code });
            })
            .catch((error) => output.error({ error }));
    },

    /**
     * Проверяем есть ли в очереди загрузка следующей страницы заказов
     * @param {Object} args
     * @param {Object} state
     * @param {Function} output
     * @param {Function} output.empty
     */
    checkLoadingQueue (args, state, output) {
        let isLoading = state.get(['account', 'orders', 'list', 'isNextPageLoading']);

        if (!isLoading) {
            output.empty();
        }
    },

    /**
     * Добавляем полученные списки заказов к существующим
     * @param {Object} args
     * @param {Object} state
     */
    addOrders ({ ordersList }, state) {
        if (_.isEmpty(ordersList)) {
            state.set(['account', 'orders', 'list', 'isAllLoaded'], true);
            return;
        }

        let currentOrdersList = state.get(['account', 'orders', 'list', 'data']) || [];
        let summaryOrdersList = currentOrdersList.concat(ordersList);
        let deduplicatedOrdersList = _.orderBy(_.uniqBy(summaryOrdersList, 'id'), function (x) {
            return parseInt(x.id, 10);
        }, 'desc');

        state.set(['account', 'orders', 'list', 'data'], deduplicatedOrdersList);
    },

    isAnyOrders (args, state, output) {
        let currentOrdersList = state.get(['account', 'orders', 'list', 'data']) || [];
        if (currentOrdersList.length > 0) {
            output.yes();
            return;
        }
        output.no();
    },

    setOrderIdArgsIfNotSet (args, state, output) {
        let orderId = args.orderId;

        // если id заказа нет в query, то ищем заказ в state, если его нет, то берём первый из списка
        if (!orderId) {
            orderId = state.get(['account', 'orders', 'currentOrder', 'id']);

            if (!orderId) {
                let currentOrdersList = state.get(['account', 'orders', 'list', 'data']) || [];
                if (currentOrdersList.length > 0) {
                    orderId = currentOrdersList[0].id;
                }
            }
        }
        output({ orderId });
    },

    /**
     * Установка словаря со статусами
     * @param {Object} args
     * @param {Object} state
     */
    setStatusFilterData (args, state) {
        state.set(['account', 'orders', 'list', 'statusFilterData'], ALL_STATUSES);
    },

    setTypeFilterData (args, state) {
        state.set(['account', 'orders', 'list', 'typeFilterData'], ALL_TYPES);
    },

    setStatusFilterItem,

    setTypeFilterItem,

    /**
     * Выбор одного статуса
     * @param {Object} args
     * @param {Object} state
     */
    selectStatus ({ key, isChecked }, state) {
        let status = Number(key);
        const statusPath = ['account', 'orders', 'list', 'selectedStatus'];

        let statusList = _.clone(state.get(statusPath)) || [];

        if (isChecked) {
            statusList.push(status);
        } else {
            statusList = _.remove(statusList, (val) => val != status);
        }

        state.set(statusPath, statusList);
    },

    getActionByTextFilter ({ textFilterValue, minLength }, state, output) {
        if (textFilterValue && textFilterValue.length >= minLength) {
            output.updateWithFilter();
        } else {
            let oldValue = state.get(['account', 'orders', 'list', 'filterText']);
            if (oldValue && oldValue.length >= minLength) {
                output.updateWithoutFilter();
            } else {
                output.none();
            }
        }
    },

    filterToLocalStorage (args, state, output, { context, locator }) {
        if (context.isServer) {
            return;
        }
        let window = locator.resolve('window');
        let ordersFilter = {};
        ordersFilter.selectedRadioFilter = state.get(['account', 'orders', 'list', 'selectedRadioFilter']);
        // ordersFilter.selectedTypeFilter = state.get(['account', 'orders', 'list', 'selectedTypeFilter']);
        ordersFilter.filterText = state.get(['account', 'orders', 'list', 'filterText']);
        ordersFilter.stateFilter = state.get(['account', 'orders', 'list', 'stateFilter']);
        ordersFilter.typeFilter = state.get(['account', 'orders', 'list', 'typeFilter']);
        window.localStorage.setItem('ordersFilter', JSON.stringify(ordersFilter));
    },

    filterRestoreFromStorage (args, state, output, { locator }) {
        let window = locator.resolve('window');
        let serialized = window.localStorage.getItem('ordersFilter');

        if (!serialized) {
            return;
        }

        let ordersFilter = JSON.parse(serialized);
        state.set(['account', 'orders', 'list', 'selectedRadioFilter'], ordersFilter.selectedRadioFilter);
        // state.set(['account', 'orders', 'list', 'selectedTypeFilter'], ordersFilter.selectedTypeFilter);
        state.set(['account', 'orders', 'list', 'filterText'], ordersFilter.filterText);
        state.set(['account', 'orders', 'list', 'stateFilter'], ordersFilter.stateFilter);
        state.set(['account', 'orders', 'list', 'typeFilter'], ordersFilter.typeFilter);
    }
};



// WEBPACK FOOTER //
// ./actions/account/orders-list.js